import {type} from 'arktype'
import type {TLanguageCode} from 'countries-list'

export const SUPPORTED_LANGUAGES = ['en'] as const satisfies TLanguageCode[]
export const SupportedLanguages = type.enumerated(...SUPPORTED_LANGUAGES)
export type SupportedLanguages = typeof SupportedLanguages.infer

export const languageAtom = atom<SupportedLanguages>('en')

export function isSupportedLanguage(language: unknown): language is SupportedLanguages {
  return (
    typeof language === 'string' && SUPPORTED_LANGUAGES.includes(language as SupportedLanguages)
  )
}

export function useLanguage() {
  return useAtom(languageAtom)
}

export function useSetLanguage() {
  return useSetAtom(languageAtom)
}
